export default {
  'categories.shoes': 'Shoes',
  'categories.hoodies': 'Hoodies & Sweaters',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jackets',
  'categories.pants': 'Pants & Shorts',
  'categories.headwear': 'Headwear',
  'categories.sets': 'Sets',
  'categories.underwear': 'Underwear',
  'categories.jersey': 'Jersey',
  'categories.accessories': 'Accessories',
  'categories.bags': 'Bags',
  'categories.belts': 'Belts',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Other Stuff',

  'nav.guides': 'Guides',
  'nav.categories': 'Categories',
  'nav.shipping': 'Shipping',
  'nav.warehouse': 'Warehouse',
  'nav.coupons': 'Coupons',
  'nav.safety': 'Safety',
  'nav.buyNow': 'Buy It Now',
  'nav.home': 'Home',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.about': 'About',

  'hero.eyebrow': 'USFANS SPREADSHEET RESOURCE CENTER',
  'hero.title': 'USFans Spreadsheet — Find, Compare & Explore Resources Faster',
  'hero.subtitle': 'Explore USFans spreadsheet resources, product research guides, reviews, shipping information, warehouse guides, coupons, safety tips and practical tutorials — all organized in one place.',
  'hero.ctaPrimary': 'Explore USFans Spreadsheet',
  'hero.ctaSecondary': 'Browse USFans Guides',
  'hero.searchPlaceholder': 'Search spreadsheets, products, sellers or guides...',
  'hero.trust': 'Independent resource • Practical guides • Regularly updated',

  'trust.1.title': 'USFans Spreadsheet',
  'trust.1.desc': 'Organized resources and practical information.',
  'trust.2.title': 'Product Research',
  'trust.2.desc': 'Compare products, sellers and useful resources.',
  'trust.3.title': 'Shipping & Warehouse',
  'trust.3.desc': 'Understand shipping, warehouse and fulfillment.',
  'trust.4.title': 'Safety First',
  'trust.4.desc': 'Verify links, sellers, prices and payment info.',

  'category.title': 'Browse Product Categories',
  'category.subtitle': 'Jump straight to any category on the main website.',
  'category.dropdownLabel': 'Choose a category',
  'category.dropdownPlaceholder': 'Select a category to continue...',

  'about.title': 'What Is a USFans Spreadsheet?',
  'about.copy': 'A USFans spreadsheet is a structured resource used to organize product information, links, sellers, categories and related shopping research. Our goal is to make that information easier to discover, understand and compare.',
  'about.cta': 'Learn How USFans Spreadsheets Work',

  'explore.title': 'Your USFans Spreadsheet Research Hub',
  'explore.subtitle': 'Everything organized in one place, from research to safety.',
  'explore.1.title': 'USFans Spreadsheet',
  'explore.2.title': 'Product Research',
  'explore.3.title': 'Seller Resources',
  'explore.4.title': 'Reviews',
  'explore.5.title': 'Shipping',
  'explore.6.title': 'Warehouse',
  'explore.7.title': 'Coupons',
  'explore.8.title': 'Safety',

  'guides.title': 'Popular USFans Guides',
  'guides.subtitle': 'Practical, original guides to help you make better decisions.',
  'guides.readMore': 'Read the guide',

  'pillars.eyebrow': 'Pillar Guides',
  'pillars.title': 'USFans Spreadsheet Pillar Guides',
  'pillars.subtitle': 'In-depth, original articles covering the core topics — from the basics to search, products, sellers and comparison.',

  'module.review.title': 'USFans Review',
  'module.review.desc': 'What to know before you use it — features, shipping, warehouse and payment.',
  'module.shipping.title': 'Shipping Cost Guide',
  'module.shipping.desc': 'How shipping costs are affected by weight, destination and method.',
  'module.coupon.title': 'Coupon & Discount Code',
  'module.coupon.desc': 'How coupons work and where to verify current promotions.',
  'module.warehouse.title': 'Warehouse Guide',
  'module.warehouse.desc': 'Storage, inspection, consolidation and packaging explained.',
  'module.safety.title': 'Is USFans Legit?',
  'module.safety.desc': 'A practical checklist to verify links, sellers and payments.',

  'cta.title': 'Ready to Explore USFans Spreadsheet Resources?',
  'cta.text': 'Start with the USFans Spreadsheet hub, explore practical guides and comparisons, then continue to the main website when you are ready to learn more.',
  'cta.primary': 'Explore USFans Spreadsheet',
  'cta.secondary': 'Visit Main Website',

  'footer.tagline': 'An independent resource hub for USFans Spreadsheet information.',
  'footer.resources': 'Resources',
  'footer.company': 'Company',
  'footer.legal': 'Legal',
  'footer.languages': 'Languages',
  'footer.disclaimer': 'This website is an independent informational resource and is not necessarily affiliated with or endorsed by USFans unless explicitly stated.',
};